const MISSING_USER_ID_HEADER = 'X-Real-UserId';

/**
 * Узнаёт ответ бэкенда о запросе без аутентификации.
 * Машиночитаемого кода у этой ошибки нет, поэтому опознаём по тексту сообщения.
 * Класс ошибки проверять нельзя: разные сервисы оборачивают её по-разному —
 * history в HttpBadStatusCodeError, sync в UnknownError
 */
export function isMissingUserIdHeaderError(error: unknown): boolean {
  return error instanceof Error && error.message.includes(MISSING_USER_ID_HEADER);
}
